export default "__VITE_ASSET__BiN_UANH__"